import React, {memo, useEffect} from 'react';
import PropTypes from 'prop-types';
import Highcharts from 'highcharts';
import AnnotationsFactory from "highcharts/modules/annotations";

AnnotationsFactory(Highcharts);
import {merge} from 'lodash';

import {GRAPH_DEFAULT} from 'utils/graph';

function Graph({component_data}) {
    const uniq_id = 'challenge-component-graph-' + Date.now() + '-' + Math.floor(Math.random() * 100);

    function draw() {
        const graph = merge({}, GRAPH_DEFAULT, component_data.data);
        Highcharts.chart(uniq_id, graph);
    }

    useEffect(() => {
        draw();
    }, []);

    return (
        <div className="challenge-component-graph">
            <div id={uniq_id}/>
        </div>
    );
}

Graph.propTypes = {
    component_data: PropTypes.shape({
        data: PropTypes.object.isRequired
    }).isRequired
}

export default memo(Graph);
